export enum LauncherMessages {
  launcherSelectModule = "launcher.select.module",
  launcherGreeting = "launcher.greeting",
  launcherActiveCount = "launcher.active.count",
  launcherContactUs = "launcher.contact.us",
  launcherNoAccessTooltip = "launcher.noAccess.tooltip",
  launcherModuleDescTech = "launcher.module.tech.desc",
  launcherModuleDescFleet = "launcher.module.fleet.desc",
  launcherModuleDescDispatch = "launcher.module.dispatch.desc",
  launcherModuleDescCustomer = "launcher.module.customer.desc",
  launcherModuleDescBi = "launcher.module.bi.desc",
  launcherModuleDescCrm = "launcher.module.crm.desc",
  launcherModuleDescBilling = "launcher.module.billing.desc",
  launcherModuleDescFinances = "launcher.module.finances.desc",
  launcherModuleDescPurchase = "launcher.module.purchase.desc",
  launcherModuleDescBatch = "launcher.module.batch.desc",
  launcherModuleDescReports = "launcher.module.reports.desc",
  launcherModuleDescBackoffice = "launcher.module.backoffice.desc",
  launcherModuleDescFmx = "launcher.module.fmx.desc",
  launcherModuleDescDriver = "launcher.module.driver.desc",
  launcherModuleDescFmxSuite = "launcher.module.fmxSuite.desc",
  launcherModuleDescIdentity = "launcher.module.identity.desc",
  launcherModuleTaglineCrm = "launcher.module.crm.tagline",
  launcherModuleTaglineBilling = "launcher.module.billing.tagline",
  launcherModuleTaglineFinances = "launcher.module.finances.tagline",
  launcherModuleTaglinePurchase = "launcher.module.purchase.tagline",
  launcherModuleTaglineBatch = "launcher.module.batch.tagline",
  launcherUpsellNote = "launcher.upsell.note",
  launcherLicenseWarning = "launcher.license.warning",
  launcherLicenseExpiredTitle = "launcher.license.expired.title",
  launcherLicenseExpiredText = "launcher.license.expired.text",
  launcherLoading = "launcher.loading",
  launcherLoadError = "launcher.loadError",
}

export interface TranslationLauncherMessages {
  [LauncherMessages.launcherSelectModule]: string;
  [LauncherMessages.launcherGreeting]: string;
  [LauncherMessages.launcherActiveCount]: string;
  [LauncherMessages.launcherContactUs]: string;
  [LauncherMessages.launcherNoAccessTooltip]: string;
  [LauncherMessages.launcherModuleDescTech]: string;
  [LauncherMessages.launcherModuleDescFleet]: string;
  [LauncherMessages.launcherModuleDescDispatch]: string;
  [LauncherMessages.launcherModuleDescCustomer]: string;
  [LauncherMessages.launcherModuleDescBi]: string;
  [LauncherMessages.launcherModuleDescCrm]: string;
  [LauncherMessages.launcherModuleDescBilling]: string;
  [LauncherMessages.launcherModuleDescFinances]: string;
  [LauncherMessages.launcherModuleDescPurchase]: string;
  [LauncherMessages.launcherModuleDescBatch]: string;
  [LauncherMessages.launcherModuleDescReports]: string;
  [LauncherMessages.launcherModuleDescBackoffice]: string;
  [LauncherMessages.launcherModuleDescFmx]: string;
  [LauncherMessages.launcherModuleDescDriver]: string;
  [LauncherMessages.launcherModuleDescFmxSuite]: string;
  [LauncherMessages.launcherModuleDescIdentity]: string;
  [LauncherMessages.launcherModuleTaglineCrm]: string;
  [LauncherMessages.launcherModuleTaglineBilling]: string;
  [LauncherMessages.launcherModuleTaglineFinances]: string;
  [LauncherMessages.launcherModuleTaglinePurchase]: string;
  [LauncherMessages.launcherModuleTaglineBatch]: string;
  [LauncherMessages.launcherUpsellNote]: string;
  [LauncherMessages.launcherLicenseWarning]: string;
  [LauncherMessages.launcherLicenseExpiredTitle]: string;
  [LauncherMessages.launcherLicenseExpiredText]: string;
  [LauncherMessages.launcherLoading]: string;
  [LauncherMessages.launcherLoadError]: string;
}
